import { type IListBehaviorConfiguration } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IListBehaviorConfigState } from './types';

export const GET_FROM_TARGET_VALUE = 'getFromTargetValue';

export const getters: GetterTree<IListBehaviorConfigState, unknown> = {
    [GET_FROM_TARGET_VALUE]: (_state: IListBehaviorConfigState) => {
        return (targetValue: string): IListBehaviorConfiguration | undefined => {
            const listBehaviorConfigId = _state.listBehaviorConfigurationByTarget.get(targetValue);
            return _state.dataObjectList.get(listBehaviorConfigId);
        };
    }
};
